import React from 'react';
import PageHeader from '../../components/PageHeader';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Drills = () => {
  return (
    <div className="w-full bg-white">
      <PageHeader 
        title="Drills & Exercises" 
        description="Testing decisions, roles, and resources without wasting operational time." 
      />
      
      <section className="py-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl font-bold text-brand-navy mb-4">Validate Your Readiness</h2>
          <p className="text-lg text-slate-600 font-medium">
            The goal of an exercise is not to stage a dramatic event. The goal is to test communications, validate plans, and expose gaps in a controlled learning environment.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {[
            { title: 'Orientation Sessions', desc: 'Low-stress introductions to new plans, roles, or facilities.' },
            { title: 'Drills', desc: 'Focused, frequent testing of a single specific operation (e.g., evacuation, hazmat donning).' },
            { title: 'Tabletop Exercises', desc: 'Discussion-based sessions evaluating plans against specific scenarios.' },
            { title: 'Functional Exercises', desc: 'Validates coordination, command, and EOC operations in simulated real-time.' },
            { title: 'Full-Scale Exercises', desc: 'High-stress, multi-agency deployment of personnel and equipment.' }
          ].map((type, i) => (
            <div key={i} className="bg-brand-light border border-slate-200 p-6 rounded-2xl hover:border-brand-green transition-colors">
              <h4 className="text-lg font-bold text-brand-navy mb-2">{type.title}</h4>
              <p className="text-sm text-slate-600 font-medium">{type.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-brand-navy text-white rounded-3xl p-8 md:p-12 shadow-xl">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-2xl font-bold mb-6 text-brand-green">Comprehensive Exercise Support</h3>
              <ul className="space-y-3 font-medium text-slate-300">
                <li className="flex items-center gap-3"><SafeIcon icon={FiIcons.FiCheck} className="text-brand-green" /> FEMA/HSEEP-aligned exercise design</li>
                <li className="flex items-center gap-3"><SafeIcon icon={FiIcons.FiCheck} className="text-brand-green" /> Realistic scenario development</li>
                <li className="flex items-center gap-3"><SafeIcon icon={FiIcons.FiCheck} className="text-brand-green" /> Expert facilitation and control</li>
                <li className="flex items-center gap-3"><SafeIcon icon={FiIcons.FiCheck} className="text-brand-green" /> Evaluator guides and rubrics</li>
                <li className="flex items-center gap-3"><SafeIcon icon={FiIcons.FiCheck} className="text-brand-green" /> Formal After-Action Reports (AAR)</li>
                <li className="flex items-center gap-3"><SafeIcon icon={FiIcons.FiCheck} className="text-brand-green" /> Improvement plans & corrective-action tracking</li>
                <li className="flex items-center gap-3"><SafeIcon icon={FiIcons.FiCheck} className="text-brand-green" /> Coordination with fire, EMS, LEPCs, & mutual-aid partners</li>
              </ul>
            </div>
            <div className="relative h-64 rounded-xl overflow-hidden border border-white/20">
              <img 
                src="https://images.unsplash.com/photo-15530e83f4bf4364765e624472b095cab?q=80&w=800&auto=format&fit=crop" 
                alt="Tabletop Exercise" 
                className="w-full h-full object-cover" 
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Drills;